import { useState, useRef } from "react";
import SliderSwitch from "./SliderSwitch";

interface Props {
  defaultValue: string;
  onChange: (newValue: string) => void;
}

const NullableInput = ({ defaultValue, onChange }: Props) => {
  const nullPlaceholder: string = "Off";
  const zeroString: string = "0";
  const [editedValue, setEditedValue] = useState<string>(defaultValue);
  const numericValueRef = useRef<string>(defaultValue === "" ? zeroString : defaultValue);

  return (
    <>
      <div className="mr-2 mt-2">
        <SliderSwitch
          defaultValue={defaultValue !== ""}
          onChange={(e) => {
            if (e.target.checked) {
              setEditedValue(numericValueRef.current);
              onChange(numericValueRef.current);
            } else {
              setEditedValue("");
              onChange("");
            }
          }}
        />
      </div>
      {editedValue === "" && <span>{nullPlaceholder}</span>}
      {editedValue !== "" && (
        <input
          type="number"
          placeholder={zeroString}
          autoComplete="off"
          defaultValue={numericValueRef.current}
          onChange={(e) => {
            const newValue = e.target.value?.length > 0 ? e.target.value : zeroString;
            setEditedValue(newValue);
            onChange(newValue);
            numericValueRef.current = newValue;
          }}
        />
      )}
    </>
  );
};

export default NullableInput;
